import { Mat3, Quat, Vec3 } from 'playcanvas';

export type GlobalClipBox = {
    enabled: boolean;
    center: Vec3;
    halfExtents: Vec3;
    rotation: Quat;
};

export const defaultGlobalClipBox = (): GlobalClipBox => ({
    enabled: false,  // Default OFF to avoid surprising clipping of newly imported meshes
    center: new Vec3(0, 0, 0),
    halfExtents: new Vec3(5, 5, 5),  // Larger default size to contain most splats
    rotation: new Quat()
});

// Returns world->boxLocal rotation matrix (inverse of box rotation).
export const calcInvRotationMat3 = (rotation: Quat): Mat3 => {
    const m = new Mat3();
    // Mat3.setFromQuat gives rotation matrix (boxLocal->world). Invert for world->boxLocal.
    m.setFromQuat(rotation);
    m.transpose();
    return m;
};
